let m = {
  setState(state, payload) {
    for (let key in payload) {
      if (!state.hasOwnProperty(key)) {
        console.warn(new Error(`state中不存在${key}这个键,请检查代码!`))
      }
      if (payload[key] != 7) {
        state[key] = payload[key]
      }
    }
  }
}
export default m
